import { DATA_REQUEST_ASYNC, UPDATE_VIP_REQUEST_ASYNC } from './constants'

const fetchData = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
const fetchDataCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })
export const fetchDataSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDataError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})

const updateVipUsersForScanback = (data) => ({
  type: UPDATE_VIP_REQUEST_ASYNC.INITIATE,
  payload: { data },
})
export const updateVipUsersForScanbackSuccess = () => ({
  type: UPDATE_VIP_REQUEST_ASYNC.SUCCESS,
})
export const updateVipUsersForScanbackError = (error) => ({
  type: UPDATE_VIP_REQUEST_ASYNC.ERROR,
  error,
})

export default {
  // to props
  fetchData,
  fetchDataCancel,
  updateVipUsersForScanback,
}
